import type { OptionTs } from "@ps-bridge/interop";
import type { LoadingErrorInput } from "@ps-bridge/controllers/loading";
import * as Option from "@utils/Option";
import { makeErrorInfoText } from "@ps-bridge/models/brands/errorInfoText";
import { makeErrorMessageText } from "@ps-bridge/models/brands/errorMessageText";

export const toLoadingErrorInput = (
    message: string,
    info: OptionTs<string>,
): LoadingErrorInput => ({
    message: makeErrorMessageText(message),
    info: Option.map(makeErrorInfoText)(info),
});
